import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4442fb4d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full py-1" }, null, -1))
const _hoisted_2 = { class: "w-full min-w-min h-full" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-row w-full h-28 bg-gray-100"
}
const _hoisted_4 = { class: "relative flex flex-col w-full h-full p-3 justify-center text-center bg-white" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ml-2 icon icon-drop",
  style: {"font-size":"7px"}
}, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "absolute top-full bg-white z-40 rounded-md shadow-2xl cursor-pointer text-left"
}
const _hoisted_7 = {
  key: 0,
  class: "w-3 h-3 mt-0.5 ml-0.5 rounded-full bg-blue-400"
}
const _hoisted_8 = {
  key: 0,
  class: "w-3 h-3 mt-0.5 ml-0.5 rounded-full bg-blue-400"
}
const _hoisted_9 = {
  key: 0,
  class: "w-3 h-3 mt-0.5 ml-0.5 rounded-full bg-blue-400"
}
const _hoisted_10 = {
  key: 0,
  class: "w-3 h-3 mt-0.5 ml-0.5 rounded-full bg-blue-400"
}
const _hoisted_11 = {
  key: 0,
  class: "w-3 h-3 mt-0.5 ml-0.5 rounded-full bg-blue-400"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "<", -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 0,
  class: "flex flex-row w-full h-28"
}
const _hoisted_15 = { class: "w-full text-center" }
const _hoisted_16 = {
  key: 1,
  class: "flex flex-row w-full h-28 items-end"
}
const _hoisted_17 = { class: "w-36 pb-6 text-center font-bold text-gray-400" }
const _hoisted_18 = { class: "flex-1 pb-6 text-center font-bold text-gray-400" }
const _hoisted_19 = { class: "relative flex flex-col w-full bg-white justify-center" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, ">", -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "flex w-full" }
const _hoisted_23 = { class: "flex w-full px-6 justify-between text-big" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-lock" }, null, -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-bin" }, null, -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Are you sure you want delete rows? ", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full py-1" }, null, -1))
const _hoisted_30 = { class: "flex flex-row w-full h-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_outline_button = _resolveComponent("outline-button")!
  const _component_modal = _resolveComponent("modal")!
  const _component_surcharge_product_details = _resolveComponent("surcharge-product-details")!
  const _component_sale_price_product_details = _resolveComponent("sale-price-product-details")!
  const _component_sale_price_cost_prices = _resolveComponent("sale-price-cost-prices")!
  const _component_sale_price_product_descriptions = _resolveComponent("sale-price-product-descriptions")!
  const _component_sale_price_actions = _resolveComponent("sale-price-actions")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", {
      id: "proposalMain",
      class: "relative overflow-x-scroll",
      ref: "proposalMain",
      onScroll: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleProposalMainScroll && _ctx.handleProposalMainScroll(...args)), ["stop","prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.fixedHeader)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["flex flex-row w-full h-28 bg-gray-100", {
              'fixed top-0 z-40 pb-2 pr-4': _ctx.fixedHeader,
              'min-w-min': !_ctx.fixedHeader,
          }]),
          ref: "proposalHeader"
        }, [
          _createElementVNode("div", {
            class: "sticky left-0 pr-2 z-40 sale-prices-table__details bg-gray-100",
            style: _normalizeStyle(`min-width: ${_ctx.minDetailsWidth}px; width: 20vw; max-width: ${1.5 * _ctx.minDetailsWidth}px;`),
            ref: "detailsSection"
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_outline_button, {
                class: "max-w-max",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.expandedSort = !_ctx.expandedSort))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('general.sort')) + " ", 1),
                  _hoisted_5
                ]),
                _: 1
              }),
              (_ctx.expandedSort)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", {
                      class: "flex flex-row pl-5 pr-24 py-3",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleSortClick('country')))
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["w-5 h-5 mt-0.5 mr-4 rounded-full border-2 border-gray-400", {
                        'border-blue-400': _ctx.sortColumn === 'country',
                    }])
                      }, [
                        (_ctx.sortColumn === 'country')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7))
                          : _createCommentVNode("", true)
                      ], 2),
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('proposal.general.country')), 1)
                    ]),
                    _createElementVNode("div", {
                      class: "flex flex-row pl-5 pr-24 py-3",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleSortClick('supplier')))
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["w-5 h-5 mt-0.5 mr-4 rounded-full border-2 border-gray-400", {
                        'border-blue-400': _ctx.sortColumn === 'supplier',
                    }])
                      }, [
                        (_ctx.sortColumn === 'supplier')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                          : _createCommentVNode("", true)
                      ], 2),
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('proposal.general.supplier')), 1)
                    ]),
                    _createElementVNode("div", {
                      class: "flex flex-row pl-5 pr-24 py-3",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleSortClick('product')))
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["w-5 h-5 mt-0.5 mr-4 rounded-full border-2 border-gray-400", {
                        'border-blue-400': _ctx.sortColumn === 'product',
                    }])
                      }, [
                        (_ctx.sortColumn === 'product')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9))
                          : _createCommentVNode("", true)
                      ], 2),
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('proposal.general.product')), 1)
                    ]),
                    _createElementVNode("div", {
                      class: "flex flex-row pl-5 pr-24 py-3",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleSortClick('contract')))
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["w-5 h-5 mt-0.5 mr-4 rounded-full border-2 border-gray-400", {
                        'border-blue-400': _ctx.sortColumn === 'contract',
                    }])
                      }, [
                        (_ctx.sortColumn === 'contract')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10))
                          : _createCommentVNode("", true)
                      ], 2),
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('proposal.general.contract')), 1)
                    ]),
                    _createElementVNode("div", {
                      class: "flex flex-row pl-5 pr-24 py-3",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleSortClick('service')))
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["w-5 h-5 mt-0.5 mr-4 rounded-full border-2 border-gray-400", {
                        'border-blue-400': _ctx.sortColumn === 'service',
                    }])
                      }, [
                        (_ctx.sortColumn === 'service')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11))
                          : _createCommentVNode("", true)
                      ], 2),
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('proposal.general.service')), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isScrollable && _ctx.isScrollableLeft)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "absolute w-6 -right-8 flex flex-col h-full cursor-pointer text-white font-bold text-medium justify-center",
                    style: {"background-color":"#2997AB"},
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.scrollLeft && _ctx.scrollLeft(...args)))
                  }, _hoisted_13))
                : _createCommentVNode("", true)
            ])
          ], 4),
          _createElementVNode("div", {
            class: _normalizeClass(["relative flex-1 bg-white", {
                'overflow-hidden': _ctx.fixedHeader,
            }]),
            ref: "pricesSection"
          }, [
            _createElementVNode("div", {
              id: "proposalWeightBracketsScroller",
              class: _normalizeClass(["flex flex-row w-full", {
                  'overflow-x-scroll': _ctx.fixedHeader,
              }]),
              style: {"height":"calc(100% + 50px)"},
              ref: "proposalWeightBracketsScroller",
              onScroll: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleProposalMainScroll && _ctx.handleProposalMainScroll(...args)), ["stop","prevent"]))
            }, [
              (!_ctx.isSurcharges)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weightBrackets, (weightBracket) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "flex flex-1 flex-col text-gray-500 font-bold justify-center align-middle",
                        style: {"min-width":"100px"},
                        key: `sale-price-weight-bracket-${weightBracket}`
                      }, [
                        _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('proposal.general.weight_bracket_header', {weight: weightBracket / 1000})), 1)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t('general.price')), 1),
                    _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t('general.description')), 1)
                  ]))
            ], 34)
          ], 2),
          _createElementVNode("div", {
            class: "sticky right-0 flex pl-2 z-40 bg-gray-100",
            style: _normalizeStyle(`${
              _ctx.isProposalEditable ?
                 `min-width: ${0.5 * _ctx.minDetailsWidth}px; width: 8vw; max-width: ${0.75 * _ctx.minDetailsWidth}px;` :
                 `max-width: 0px; padding: 0;`
            }`),
            ref: "actionsSection"
          }, [
            _createElementVNode("div", _hoisted_19, [
              (_ctx.isScrollable && _ctx.isScrollableRight)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["absolute w-6 flex flex-col h-full cursor-pointer text-white font-bold text-medium justify-center", {
                    '-left-8': _ctx.isProposalEditable,
                    '-left-6': !_ctx.isProposalEditable,
                }]),
                    style: {"background-color":"#2997AB"},
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.scrollRight && _ctx.scrollRight(...args)))
                  }, _hoisted_21, 2))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  (_ctx.hasSelectedElements)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleBlockClick && _ctx.handleBlockClick(...args))),
                        class: _normalizeClass({'text-green-dark': !_ctx.blockGrossMargin})
                      }, _hoisted_25, 2))
                    : _createCommentVNode("", true),
                  (_ctx.hasSelectedElements)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showDeleteConfirm = true))
                      }, _hoisted_27))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ], 4),
          _createVNode(_component_modal, {
            modelValue: _ctx.showDeleteConfirm,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.showDeleteConfirm) = $event)),
            onConfirmClick: _ctx.handleDeleteClick
          }, {
            title: _withCtx(() => [
              _createTextVNode("Warning")
            ]),
            default: _withCtx(() => [
              _hoisted_28
            ]),
            _: 1
          }, 8, ["modelValue", "onConfirmClick"])
        ], 2),
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.salePricesRows, (salePriceRow) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: `sale-price-row-${salePriceRow.id}`
            }, [
              _hoisted_29,
              _createElementVNode("div", _hoisted_30, [
                (_ctx.isSurcharges)
                  ? (_openBlock(), _createBlock(_component_surcharge_product_details, {
                      key: 0,
                      class: "sticky left-0 z-30 flex pr-2 bg-gray-100",
                      style: _normalizeStyle(`min-width: ${_ctx.minDetailsWidth}px; width: 20vw; max-width: ${1.5 * _ctx.minDetailsWidth}px;`),
                      "sale-price-row": salePriceRow
                    }, null, 8, ["style", "sale-price-row"]))
                  : (_openBlock(), _createBlock(_component_sale_price_product_details, {
                      key: 1,
                      class: "sticky left-0 z-30 flex pr-2 bg-gray-100",
                      style: _normalizeStyle(`min-width: ${_ctx.minDetailsWidth}px; width: 20vw; max-width: ${1.5 * _ctx.minDetailsWidth}px;`),
                      "sale-price-row": salePriceRow
                    }, null, 8, ["style", "sale-price-row"])),
                _createVNode(_component_sale_price_cost_prices, {
                  class: _normalizeClass({
                  'flex-0 w-36': _ctx.isSurcharges,
                  'flex-1': !_ctx.isSurcharges,
                }),
                  "sale-price-row": salePriceRow,
                  "weight-brackets": _ctx.weightBrackets
                }, null, 8, ["class", "sale-price-row", "weight-brackets"]),
                (_ctx.isSurcharges)
                  ? (_openBlock(), _createBlock(_component_sale_price_product_descriptions, {
                      key: 2,
                      modelValue: salePriceRow.description,
                      "onUpdate:modelValue": ($event: any) => ((salePriceRow.description) = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                  : _createCommentVNode("", true),
                (_ctx.isProposalEditable)
                  ? (_openBlock(), _createBlock(_component_sale_price_actions, {
                      key: 3,
                      class: "sticky right-0 z-30 flex pl-2 bg-gray-100",
                      style: _normalizeStyle(`min-width: ${0.5 * _ctx.minDetailsWidth}px; width: 8vw; max-width: ${0.75 * _ctx.minDetailsWidth}px;`),
                      isSurcharges: _ctx.isSurcharges,
                      selected: salePriceRow.selected,
                      "onUpdate:selected": ($event: any) => ((salePriceRow.selected) = $event),
                      "gross-margin": salePriceRow.grossMargin,
                      "onUpdate:grossMargin": ($event: any) => ((salePriceRow.grossMargin) = $event)
                    }, null, 8, ["style", "isSurcharges", "selected", "onUpdate:selected", "gross-margin", "onUpdate:grossMargin"]))
                  : _createCommentVNode("", true)
              ])
            ], 64))
          }), 128))
        ])
      ])
    ], 544)
  ], 64))
}